// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Colors */

:root {
    --color-primary: #00f0ff;
    --color-secondary: #6c5ce7;
    --color-accent: #2dd4bf;
    --color-background: #0a0f24;
    --color-surface: #151a2e;
    --color-border: #2a2f45;
    --color-text: #e0e0e0;
    --color-text-light: #a0a0a0;
    --color-success: #4caf50;
    --color-error: #ff5252;
    --color-warning: #ffc107;
    --color-info: #2196f3;
    --color-ship-hover: rgba(0, 240, 255, 0.3);
    --color-ship-invalid: #ff525280;
    --color-hit: #ff5252;
    --color-miss: #2196f3;
    --color-sunk: #ff5252;
    --color-board-background: #151a2e;
    --color-board-border: #2a2f45;
    --color-overlay: rgba(0, 240, 255, 0.1);
    --color-dark-overlay: rgba(0, 0, 0, 0.85);
    --scrollbar-track: #151a2e;
    --scrollbar-thumb: #2a2f45;
    --scrollbar-thumb-hover: #3b4055;

    --ship-filter: invert(50%) sepia(34%) saturate(353%) hue-rotate(192deg) brightness(99%) contrast(90%);
}

/* Reset */

*,
*::before,
*::after {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

body {
    -webkit-font-smoothing: antialiased;
    line-height: 1.5;
}

img,
picture,
video,
canvas,
svg {
    display: block;
    max-width: 100%;
}

input,
button,
textarea,
select,
dialog,
form,
label {
    font: inherit;
    color: inherit;
    outline: none;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
    overflow-wrap: break-word;
}

p {
    text-wrap: pretty;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    text-wrap: balance;
}

#root,
#__next {
    isolation: isolate;
}

ul,
li {
    list-style-type: none;
    list-style: none;
}

a {
    text-decoration: none;
    color: inherit;
}

button {
    all: unset;
}

button,
label[for],
select,
option,
::-webkit-search-cancel-button,
::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
    cursor: pointer;
}

/* General */

.container {
    width: 95%;
    margin: 0 auto;
    max-width: 1200px;
    border: 2px solid var(--color-border);
    border-radius: 10px;
}

.neon-snake {
    position: absolute;
    width: 16px;
    height: 16px;
    background: var(--neon-color);
    border-radius: 50%;
    box-shadow:
        0 0 10px var(--neon-color),
        0 0 20px var(--neon-color);
    animation: snake-move 4s linear infinite;
}

.row {
    display: flex;
}

body {
    min-height: 100svh;
    display: grid;
    place-items: center;
    background-color: var(--color-background);
    font-family: "Segoe UI", system-ui, sans-serif;
    color: var(--color-text);
}

/* Main menu */

.main {
    background-color: var(--color-surface);
    display: flex;
    flex-direction: column;
    min-width: 80%;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.menu__main {
    align-items: center;
    justify-content: space-evenly;
    gap: 1em;
    padding: 1em 0;
    min-height: 95%;
    overflow-x: hidden;
}

#title {
    text-align: center;
    width: 100%;
    letter-spacing: 1.2rem;
    font-weight: 900;
    font-size: 3rem;
    color: var(--color-text);
    animation: glow 2s ease-in-out infinite alternate;
    transform-style: preserve-3d;
    position: relative;
    transform: perspective(800px) rotateX(25deg);
    transform-origin: top center;
}

#title::after {
    content: "";
    position: absolute;
    top: 0;
    left: -75%;
    width: 50%;
    height: 100%;
    background: linear-gradient(120deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.1));
    transform: skewX(-30deg);
    animation: sheen 2.5s forwards;
    pointer-events: none;
    opacity: 0;
}

/* Player Containers */

.player-containers {
    width: 100%;
    justify-content: space-evenly;
    gap: 1em;
    padding: 0 1em;
}

.player-container {
    position: relative;
    display: grid;
    grid-auto-flow: row;
    justify-content: space-evenly;
    gap: 1.5em;
    align-items: center;
    justify-items: center;
    background-color: var(--color-surface);
    border: 2px solid var(--color-border);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    padding: 1.5em 0em;
    border-radius: 1em;
}

.game-board.dark-overlay::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: black;
    animation: shrink 0.5s ease-in-out;
}

.player-container__upper-row {
    display: grid;
    grid-template-columns: 5fr 1fr;
    width: 75%;
    align-items: center;
}

.dropdown-container {
    gap: 1em;
}

label {
    display: flex;
    align-items: center;
}

select {
    padding: 0.3em 0.6em;
    border-radius: 8px;
    background: var(--color-surface);
    border: 1px solid var(--color-border);
    margin: 0 auto;
}

.visibility-toggle {
    justify-self: end;
    transition: transform 0.3s ease;
    cursor: auto;
}

.visibility-toggle.can-click {
    cursor: pointer;
}

.visibility-toggle.can-click:hover {
    transform: scale(1.1);
}

#startBtn {
    padding: 0.6rem 5rem;
    background: var(--color-primary);
    color: var(--color-background);
    border-radius: 8px;
    font-weight: bold;
    font-size: 1.2em;
    transition:
        transform 0.3s ease,
        box-shadow 0.3s ease;
    box-shadow: 0 4px 16px rgba(0, 240, 255, 0.3);
}

#startBtn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(0, 240, 255, 0.5);
}

/* Ship list */

.ship-list {
    display: flex;
    justify-content: space-between;
    overflow-x: auto;
    border: 1px solid var(--color-border);
    background-color: var(--color-surface);
    width: 75%;
    max-width: 900px;
    min-height: 6.5rem;
}

.ship-list__item {
    display: flex;
    flex-direction: column;
    padding: 1em 1em;
    align-items: center;
    transition: transform 0.2s ease;
    min-width: 7rem;
}

.ship-list__item:hover {
    transform: translateY(-3px);
}

.img-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ship__img,
.board__ship {
    filter: var(--ship-filter);
}

.ship__img[draggable="true"] {
    width: 4rem;
    transition: filter 0.3s ease;
}

.ship__img[draggable="true"]:hover {
    cursor: grab;
}

.ship__img[draggable="true"]:active {
    cursor: grabbing;
}

[data-ship="battleship"] {
    aspect-ratio: 299 / 95;
}

[data-ship="carrier"] {
    aspect-ratio: 302 / 98;
}

[data-ship="cruiser"] {
    aspect-ratio: 153 / 69;
}

[data-ship="destroyer"] {
    aspect-ratio: 1.87 / 1;
}

[data-ship="submarine"] {
    aspect-ratio: 302 / 98;
    transform: translateY(15.5%); /* the svg is a little wonky */
}

.ship-list::-webkit-scrollbar {
    height: 5px;
}

.ship-list::-webkit-scrollbar-track {
    background: var(--scrollbar-track);
}

.ship-list::-webkit-scrollbar-thumb {
    background: var(--scrollbar-thumb);
}

.ship-list::-webkit-scrollbar-thumb:hover {
    background: var(--scrollbar-thumb-hover);
}

/* Board */

.game-board {
    position: relative;
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    grid-template-rows: repeat(10, 1fr);
    background-color: var(--color-board-background);
    aspect-ratio: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    border: 2px solid var(--color-border);
    border-radius: 8px;
    transform: scale(1);
    transition:
        transform 0.4s ease-in-out,
        box-shadow,
        0.4s ease-in-out;
    animation: none;
}

.menu__main .game-board:hover {
    box-shadow: 0 0 20px rgba(0, 240, 255, 0.1);
}

.menu__main .game-board {
    width: min(70%, 350px);
}

.cell {
    border: 1px solid var(--color-border);
    transition: all 0.2s ease;
}

.cell.ship__hover {
    background-color: var(--color-ship-hover);
}

.cell.invalid {
    background-color: var(--color-ship-invalid);
}

.board__ship-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    height: 10%;
    pointer-events: none;
    &.vertical {
        transform-origin: top left;
        transform: rotate(90deg) translateY(-100%);
    }
}

.board__ship {
    width: 90%;
    height: 95%;
}

/* Button list */

.button-list {
    width: 75%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 0.4em;
}

.menu-button {
    flex: 1;
    font-size: 0.9rem;
    text-align: center;
    padding: 0.2em 0.4em;
    background-color: var(--color-board-background);
    border-radius: 8px;
    border: 1px solid var(--color-border);
    transition: all 0.3s ease;
    flex-wrap: wrap;
}

.menu-button.active {
    background-color: var(--color-primary);
    color: var(--color-background);
    box-shadow: 0 0 12px var(--color-primary);
}

.menu-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 240, 255, 0.2);
}

/* Game */

.game-main {
    justify-content: center;
    min-height: 80vh;
}

.board-container {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
}

.game-main .game-board {
    min-width: 40%;
    overflow: hidden; /* For the glowing cells */
}

.game-board.current-board {
    position: relative;
    overflow: hidden;
    transform: scale(1.05);
    box-shadow: 0 0 20px rgba(0, 240, 255, 0.1);
}

.pass-device-button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    padding: 0.6rem 1.5rem;
    background-color: var(--color-primary);
    color: var(--color-background);
    border: 2px solid var(--color-border);
    border-radius: 1rem;
    font-size: 1rem;
    width: 22ch;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    box-shadow: 0 0 20px rgba(0, 240, 255, 0.4);
    transition: all 0.3s ease-in-out;
    animation:
        fadeInUp 1s ease-out forwards,
        glow 1s ease-in-out infinite alternate;
}

.pass-device-button:hover {
    transform: translate(-50%, -50%) scale(1.05);
    box-shadow: 0 0 30px rgba(0, 240, 255, 0.6);
    color: var(--color-text);
}

/* Cells */

.miss {
    background-color: var(--color-miss);
    position: relative;
    overflow: hidden;
}

.cell.miss::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 150%;
    height: 150%;
    background: rgba(255, 255, 255, 0.5);
    transform: translate(-50%, -50%);
    border-radius: 50%;
    animation: rippleEffect 1s ease-out forwards;
}

.hit {
    background-color: var(--color-hit);
    animation:
        pulseHit 0.4s ease,
        shake 0.4s ease,
        infiniteGlow 3s ease-in-out 0.8s infinite;
}

.sunk {
    background-color: var(--color-sunk);
}

.boom {
    animation:
        sink 0.4s ease-in-out,
        shake 0.4s ease 0.4s forwards,
        infiniteGlow 3s ease-in-out 0.8s infinite;
}

.cell.hover:hover {
    cursor: pointer;
    background-color: var(--color-accent);
}

/**** Animations ****/

/* Text */
@keyframes glow {
    from {
        text-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
    }
    to {
        text-shadow: 0 0 20px rgba(0, 240, 255, 0.8);
    }
}

@keyframes sheen {
    0% {
        left: -75%;
        opacity: 0;
    }
    25% {
        opacity: 1;
    }
    50% {
        left: 50%;
        opacity: 1;
    }
    100% {
        left: 125%;
        opacity: 0;
    }
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
}

/* Cells */
@keyframes pulseHit {
    0% {
        transform: scale(1);
    }
    70% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes sink {
    from {
        transform: scale(3);
        box-shadow: 0 0 20px rgba(255, 0, 0, 1);
    }
    to {
        transform: scale(1);
        box-shadow: none;
    }
}

@keyframes shake {
    0% {
        transform: translateX(0);
    }
    25% {
        transform: translateX(-4px);
    }
    50% {
        transform: translateX(4px);
    }
    75% {
        transform: translateX(-4px);
    }
    100% {
        transform: translateX(0);
    }
}

@keyframes infiniteGlow {
    0% {
        box-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
    }
    50% {
        box-shadow: 0 0 30px rgba(255, 0, 0, 1);
    }
    100% {
        box-shadow: 0 0 10px rgba(255, 0, 0, 0.5);
    }
}

@keyframes rippleEffect {
    0% {
        transform: scale(0);
        opacity: 1;
    }
    100% {
        transform: scale(4);
        opacity: 0;
    }
}

/* dark overlay */
@keyframes shrink {
    from {
        transform: scale(1.1);
    }

    scale {
        transform: scale(1);
    }
}

/* Media Queries */

@media (max-height: 850px) and (min-width: 1080px) {
    .player-container {
        grid-template-rows: auto 12fr auto auto;
        grid-template-columns: 3fr 1fr;
        gap: 0;
        row-gap: 1em;
        column-gap: 1em;
        padding: 1em 2em;
    }

    .player-container__upper-row {
        grid-row: 1 / 2;
        grid-column: 1 / -1;
    }

    .ship-list {
        grid-row: 2 / -1;
        grid-column: 2;
        width: 100%;
        min-width: 12ch;
        height: 90%;
        flex-direction: column;
        overflow-y: auto;
    }

    .ship-list::-webkit-scrollbar {
        height: 0px;
        width: 5px;
    }

    .menu__main .game-board {
        grid-row: 2 / 3;
        grid-column: 1 / 2;
        width: 100%;
    }

    .button-list {
        grid-row: 3;
        grid-column: 1 / 2;
        width: 100%;
    }

    .menu-button {
        padding: 0.2em 0;
    }

    .player-container__upper-row {
        width: 100%;
    }

    .dropdown-container {
        margin: 0 auto;
    }
}

@media (max-width: 1080px) {
    .menu__main {
        margin: 2em 0;
    }

    .dropdown-container {
        margin: 0 auto;
    }

    .player-containers {
        flex-direction: column;
        align-items: center;
    }

    .player-container {
        width: 90%;
        max-width: 500px;
    }

    .menu__main .game-board {
        width: 80%;
    }

    .ship-list,
    .button-list {
        width: 90%;
    }
}

@media (max-width: 786px) {
    .game-main {
        margin: 2em 0;
    }

    .board-container {
        flex-direction: column;
        padding: 3rem 0;
        gap: 3em;
    }

    .game-main {
        min-height: 95%;
    }

    .game-main .game-board {
        width: 80%;
    }

    .pass-device-button {
        font-size: 0.7rem;
        padding: 0.5rem 1rem;
    }

    #startBtn {
        padding: 0.3em 2.5em;
    }

    .player-containers {
        margin: 1.2em 0;
    }
}

@media (max-width: 580px) {
    #title {
        letter-spacing: 8px;
        font-size: 2.5rem;
    }

    .button-list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(12ch, 1fr));
        gap: 0.4em;
    }

    .dropdown-container {
        flex-direction: column;
        margin: 0;
    }

    .player-containers {
        padding: 0;
    }

    select {
        margin: 0;
        width: 80%;
    }

    .board-container {
        padding: 0.5em 0;
    }

    .game-main {
        justify-content: space-evenly;
    }
}

@media (max-width: 480px) {
    #title {
        font-size: 1.8rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;IACI,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;IAC3B,wBAAwB;IACxB,sBAAsB;IACtB,wBAAwB;IACxB,qBAAqB;IACrB,0CAA0C;IAC1C,+BAA+B;IAC/B,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,iCAAiC;IACjC,6BAA6B;IAC7B,uCAAuC;IACvC,yCAAyC;IACzC,0BAA0B;IAC1B,0BAA0B;IAC1B,gCAAgC;;IAEhC,qGAAqG;AACzG;;AAEA,UAAU;;AAEV;;;IAGI,UAAU;IACV,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;AACpB;;AAEA;;;;;IAKI,cAAc;IACd,eAAe;AACnB;;AAEA;;;;;;;IAOI,aAAa;IACb,cAAc;IACd,aAAa;AACjB;;AAEA;;;;;;;IAOI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;;IAMI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;;;;;;;IAOI,eAAe;AACnB;;AAEA,YAAY;;AAEZ;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;IAClB;;kCAE8B;IAC9B,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;IACzC,8CAA8C;IAC9C,wBAAwB;AAC5B;;AAEA,cAAc;;AAEd;IACI,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,QAAQ;IACR,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,iDAAiD;IACjD,4BAA4B;IAC5B,kBAAkB;IAClB,4CAA4C;IAC5C,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,UAAU;IACV,YAAY;IACZ,iHAAiH;IACjH,wBAAwB;IACxB,8BAA8B;IAC9B,oBAAoB;IACpB,UAAU;AACd;;AAEA,sBAAsB;;AAEtB;IACI,WAAW;IACX,6BAA6B;IAC7B,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,UAAU;IACV,mBAAmB;IACnB,qBAAqB;IACrB,sCAAsC;IACtC,qCAAqC;IACrC,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB;;4BAEwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,cAAc;;AAEd;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,qCAAqC;IACrC,sCAAsC;IACtC,UAAU;IACV,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,4BAA4B,EAAE,8BAA8B;AAChE;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA,UAAU;;AAEV;IACI,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,mCAAmC;IACnC,+CAA+C;IAC/C,eAAe;IACf,uCAAuC;IACvC,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB;;;wBAGoB;IACpB,eAAe;AACnB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB;QACI,0BAA0B;QAC1B,0CAA0C;IAC9C;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA,gBAAgB;;AAEhB;IACI,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,+CAA+C;IAC/C,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sCAAsC;IACtC,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,SAAS;;AAET;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB,EAAE,0BAA0B;AAChD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,sCAAsC;IACtC,8BAA8B;IAC9B,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,2CAA2C;IAC3C,gCAAgC;IAChC;;8CAE0C;AAC9C;;AAEA;IACI,4CAA4C;IAC5C,2CAA2C;IAC3C,wBAAwB;AAC5B;;AAEA,UAAU;;AAEV;IACI,mCAAmC;IACnC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,gCAAgC;IAChC,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;IAClC;;;iDAG6C;AACjD;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI;;;iDAG6C;AACjD;;AAEA;IACI,eAAe;IACf,qCAAqC;AACzC;;AAEA,qBAAqB;;AAErB,SAAS;AACT;IACI;QACI,4CAA4C;IAChD;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI;QACI,UAAU;QACV,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,SAAS;QACT,UAAU;IACd;IACA;QACI,UAAU;QACV,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;IACA;QACI,UAAU;QACV,gCAAgC;IACpC;AACJ;;AAEA,UAAU;AACV;IACI;QACI,mBAAmB;IACvB;IACA;QACI,qBAAqB;IACzB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,uCAAuC;IAC3C;IACA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,yCAAyC;IAC7C;IACA;QACI,uCAAuC;IAC3C;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,iBAAiB;AACjB;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA,kBAAkB;;AAElB;IACI;QACI,uCAAuC;QACvC,8BAA8B;QAC9B,MAAM;QACN,YAAY;QACZ,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,WAAW;QACX,eAAe;QACf,WAAW;QACX,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,0DAA0D;QAC1D,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["/* Colors */\n\n:root {\n    --color-primary: #00f0ff;\n    --color-secondary: #6c5ce7;\n    --color-accent: #2dd4bf;\n    --color-background: #0a0f24;\n    --color-surface: #151a2e;\n    --color-border: #2a2f45;\n    --color-text: #e0e0e0;\n    --color-text-light: #a0a0a0;\n    --color-success: #4caf50;\n    --color-error: #ff5252;\n    --color-warning: #ffc107;\n    --color-info: #2196f3;\n    --color-ship-hover: rgba(0, 240, 255, 0.3);\n    --color-ship-invalid: #ff525280;\n    --color-hit: #ff5252;\n    --color-miss: #2196f3;\n    --color-sunk: #ff5252;\n    --color-board-background: #151a2e;\n    --color-board-border: #2a2f45;\n    --color-overlay: rgba(0, 240, 255, 0.1);\n    --color-dark-overlay: rgba(0, 0, 0, 0.85);\n    --scrollbar-track: #151a2e;\n    --scrollbar-thumb: #2a2f45;\n    --scrollbar-thumb-hover: #3b4055;\n\n    --ship-filter: invert(50%) sepia(34%) saturate(353%) hue-rotate(192deg) brightness(99%) contrast(90%);\n}\n\n/* Reset */\n\n*,\n*::before,\n*::after {\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n}\n\nbody {\n    -webkit-font-smoothing: antialiased;\n    line-height: 1.5;\n}\n\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n    display: block;\n    max-width: 100%;\n}\n\ninput,\nbutton,\ntextarea,\nselect,\ndialog,\nform,\nlabel {\n    font: inherit;\n    color: inherit;\n    outline: none;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    overflow-wrap: break-word;\n}\n\np {\n    text-wrap: pretty;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    text-wrap: balance;\n}\n\n#root,\n#__next {\n    isolation: isolate;\n}\n\nul,\nli {\n    list-style-type: none;\n    list-style: none;\n}\n\na {\n    text-decoration: none;\n    color: inherit;\n}\n\nbutton {\n    all: unset;\n}\n\nbutton,\nlabel[for],\nselect,\noption,\n::-webkit-search-cancel-button,\n::-webkit-scrollbar-thumb,\n::-webkit-scrollbar-track {\n    cursor: pointer;\n}\n\n/* General */\n\n.container {\n    width: 95%;\n    margin: 0 auto;\n    max-width: 1200px;\n    border: 2px solid var(--color-border);\n    border-radius: 10px;\n}\n\n.neon-snake {\n    position: absolute;\n    width: 16px;\n    height: 16px;\n    background: var(--neon-color);\n    border-radius: 50%;\n    box-shadow:\n        0 0 10px var(--neon-color),\n        0 0 20px var(--neon-color);\n    animation: snake-move 4s linear infinite;\n}\n\n.row {\n    display: flex;\n}\n\nbody {\n    min-height: 100svh;\n    display: grid;\n    place-items: center;\n    background-color: var(--color-background);\n    font-family: \"Segoe UI\", system-ui, sans-serif;\n    color: var(--color-text);\n}\n\n/* Main menu */\n\n.main {\n    background-color: var(--color-surface);\n    display: flex;\n    flex-direction: column;\n    min-width: 80%;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n}\n\n.menu__main {\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 1em;\n    padding: 1em 0;\n    min-height: 95%;\n    overflow-x: hidden;\n}\n\n#title {\n    text-align: center;\n    width: 100%;\n    letter-spacing: 1.2rem;\n    font-weight: 900;\n    font-size: 3rem;\n    color: var(--color-text);\n    animation: glow 2s ease-in-out infinite alternate;\n    transform-style: preserve-3d;\n    position: relative;\n    transform: perspective(800px) rotateX(25deg);\n    transform-origin: top center;\n}\n\n#title::after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: -75%;\n    width: 50%;\n    height: 100%;\n    background: linear-gradient(120deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.1));\n    transform: skewX(-30deg);\n    animation: sheen 2.5s forwards;\n    pointer-events: none;\n    opacity: 0;\n}\n\n/* Player Containers */\n\n.player-containers {\n    width: 100%;\n    justify-content: space-evenly;\n    gap: 1em;\n    padding: 0 1em;\n}\n\n.player-container {\n    position: relative;\n    display: grid;\n    grid-auto-flow: row;\n    justify-content: space-evenly;\n    gap: 1.5em;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--color-surface);\n    border: 2px solid var(--color-border);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n    padding: 1.5em 0em;\n    border-radius: 1em;\n}\n\n.game-board.dark-overlay::after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background-color: black;\n    animation: shrink 0.5s ease-in-out;\n}\n\n.player-container__upper-row {\n    display: grid;\n    grid-template-columns: 5fr 1fr;\n    width: 75%;\n    align-items: center;\n}\n\n.dropdown-container {\n    gap: 1em;\n}\n\nlabel {\n    display: flex;\n    align-items: center;\n}\n\nselect {\n    padding: 0.3em 0.6em;\n    border-radius: 8px;\n    background: var(--color-surface);\n    border: 1px solid var(--color-border);\n    margin: 0 auto;\n}\n\n.visibility-toggle {\n    justify-self: end;\n    transition: transform 0.3s ease;\n    cursor: auto;\n}\n\n.visibility-toggle.can-click {\n    cursor: pointer;\n}\n\n.visibility-toggle.can-click:hover {\n    transform: scale(1.1);\n}\n\n#startBtn {\n    padding: 0.6rem 5rem;\n    background: var(--color-primary);\n    color: var(--color-background);\n    border-radius: 8px;\n    font-weight: bold;\n    font-size: 1.2em;\n    transition:\n        transform 0.3s ease,\n        box-shadow 0.3s ease;\n    box-shadow: 0 4px 16px rgba(0, 240, 255, 0.3);\n}\n\n#startBtn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 24px rgba(0, 240, 255, 0.5);\n}\n\n/* Ship list */\n\n.ship-list {\n    display: flex;\n    justify-content: space-between;\n    overflow-x: auto;\n    border: 1px solid var(--color-border);\n    background-color: var(--color-surface);\n    width: 75%;\n    max-width: 900px;\n    min-height: 6.5rem;\n}\n\n.ship-list__item {\n    display: flex;\n    flex-direction: column;\n    padding: 1em 1em;\n    align-items: center;\n    transition: transform 0.2s ease;\n    min-width: 7rem;\n}\n\n.ship-list__item:hover {\n    transform: translateY(-3px);\n}\n\n.img-container {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.ship__img,\n.board__ship {\n    filter: var(--ship-filter);\n}\n\n.ship__img[draggable=\"true\"] {\n    width: 4rem;\n    transition: filter 0.3s ease;\n}\n\n.ship__img[draggable=\"true\"]:hover {\n    cursor: grab;\n}\n\n.ship__img[draggable=\"true\"]:active {\n    cursor: grabbing;\n}\n\n[data-ship=\"battleship\"] {\n    aspect-ratio: 299 / 95;\n}\n\n[data-ship=\"carrier\"] {\n    aspect-ratio: 302 / 98;\n}\n\n[data-ship=\"cruiser\"] {\n    aspect-ratio: 153 / 69;\n}\n\n[data-ship=\"destroyer\"] {\n    aspect-ratio: 1.87 / 1;\n}\n\n[data-ship=\"submarine\"] {\n    aspect-ratio: 302 / 98;\n    transform: translateY(15.5%); /* the svg is a little wonky */\n}\n\n.ship-list::-webkit-scrollbar {\n    height: 5px;\n}\n\n.ship-list::-webkit-scrollbar-track {\n    background: var(--scrollbar-track);\n}\n\n.ship-list::-webkit-scrollbar-thumb {\n    background: var(--scrollbar-thumb);\n}\n\n.ship-list::-webkit-scrollbar-thumb:hover {\n    background: var(--scrollbar-thumb-hover);\n}\n\n/* Board */\n\n.game-board {\n    position: relative;\n    display: grid;\n    grid-template-columns: repeat(10, 1fr);\n    grid-template-rows: repeat(10, 1fr);\n    background-color: var(--color-board-background);\n    aspect-ratio: 1;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n    border: 2px solid var(--color-border);\n    border-radius: 8px;\n    transform: scale(1);\n    transition:\n        transform 0.4s ease-in-out,\n        box-shadow,\n        0.4s ease-in-out;\n    animation: none;\n}\n\n.menu__main .game-board:hover {\n    box-shadow: 0 0 20px rgba(0, 240, 255, 0.1);\n}\n\n.menu__main .game-board {\n    width: min(70%, 350px);\n}\n\n.cell {\n    border: 1px solid var(--color-border);\n    transition: all 0.2s ease;\n}\n\n.cell.ship__hover {\n    background-color: var(--color-ship-hover);\n}\n\n.cell.invalid {\n    background-color: var(--color-ship-invalid);\n}\n\n.board__ship-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    height: 10%;\n    pointer-events: none;\n    &.vertical {\n        transform-origin: top left;\n        transform: rotate(90deg) translateY(-100%);\n    }\n}\n\n.board__ship {\n    width: 90%;\n    height: 95%;\n}\n\n/* Button list */\n\n.button-list {\n    width: 75%;\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 0.4em;\n}\n\n.menu-button {\n    flex: 1;\n    font-size: 0.9rem;\n    text-align: center;\n    padding: 0.2em 0.4em;\n    background-color: var(--color-board-background);\n    border-radius: 8px;\n    border: 1px solid var(--color-border);\n    transition: all 0.3s ease;\n    flex-wrap: wrap;\n}\n\n.menu-button.active {\n    background-color: var(--color-primary);\n    color: var(--color-background);\n    box-shadow: 0 0 12px var(--color-primary);\n}\n\n.menu-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 240, 255, 0.2);\n}\n\n/* Game */\n\n.game-main {\n    justify-content: center;\n    min-height: 80vh;\n}\n\n.board-container {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 100%;\n}\n\n.game-main .game-board {\n    min-width: 40%;\n    overflow: hidden; /* For the glowing cells */\n}\n\n.game-board.current-board {\n    position: relative;\n    overflow: hidden;\n    transform: scale(1.05);\n    box-shadow: 0 0 20px rgba(0, 240, 255, 0.1);\n}\n\n.pass-device-button {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 10;\n    padding: 0.6rem 1.5rem;\n    background-color: var(--color-primary);\n    color: var(--color-background);\n    border: 2px solid var(--color-border);\n    border-radius: 1rem;\n    font-size: 1rem;\n    width: 22ch;\n    text-align: center;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    box-shadow: 0 0 20px rgba(0, 240, 255, 0.4);\n    transition: all 0.3s ease-in-out;\n    animation:\n        fadeInUp 1s ease-out forwards,\n        glow 1s ease-in-out infinite alternate;\n}\n\n.pass-device-button:hover {\n    transform: translate(-50%, -50%) scale(1.05);\n    box-shadow: 0 0 30px rgba(0, 240, 255, 0.6);\n    color: var(--color-text);\n}\n\n/* Cells */\n\n.miss {\n    background-color: var(--color-miss);\n    position: relative;\n    overflow: hidden;\n}\n\n.cell.miss::after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 150%;\n    height: 150%;\n    background: rgba(255, 255, 255, 0.5);\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    animation: rippleEffect 1s ease-out forwards;\n}\n\n.hit {\n    background-color: var(--color-hit);\n    animation:\n        pulseHit 0.4s ease,\n        shake 0.4s ease,\n        infiniteGlow 3s ease-in-out 0.8s infinite;\n}\n\n.sunk {\n    background-color: var(--color-sunk);\n}\n\n.boom {\n    animation:\n        sink 0.4s ease-in-out,\n        shake 0.4s ease 0.4s forwards,\n        infiniteGlow 3s ease-in-out 0.8s infinite;\n}\n\n.cell.hover:hover {\n    cursor: pointer;\n    background-color: var(--color-accent);\n}\n\n/**** Animations ****/\n\n/* Text */\n@keyframes glow {\n    from {\n        text-shadow: 0 0 10px rgba(0, 240, 255, 0.4);\n    }\n    to {\n        text-shadow: 0 0 20px rgba(0, 240, 255, 0.8);\n    }\n}\n\n@keyframes sheen {\n    0% {\n        left: -75%;\n        opacity: 0;\n    }\n    25% {\n        opacity: 1;\n    }\n    50% {\n        left: 50%;\n        opacity: 1;\n    }\n    100% {\n        left: 125%;\n        opacity: 0;\n    }\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translate(-50%, -60%);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%);\n    }\n}\n\n/* Cells */\n@keyframes pulseHit {\n    0% {\n        transform: scale(1);\n    }\n    70% {\n        transform: scale(1.2);\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes sink {\n    from {\n        transform: scale(3);\n        box-shadow: 0 0 20px rgba(255, 0, 0, 1);\n    }\n    to {\n        transform: scale(1);\n        box-shadow: none;\n    }\n}\n\n@keyframes shake {\n    0% {\n        transform: translateX(0);\n    }\n    25% {\n        transform: translateX(-4px);\n    }\n    50% {\n        transform: translateX(4px);\n    }\n    75% {\n        transform: translateX(-4px);\n    }\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes infiniteGlow {\n    0% {\n        box-shadow: 0 0 10px rgba(255, 0, 0, 0.5);\n    }\n    50% {\n        box-shadow: 0 0 30px rgba(255, 0, 0, 1);\n    }\n    100% {\n        box-shadow: 0 0 10px rgba(255, 0, 0, 0.5);\n    }\n}\n\n@keyframes rippleEffect {\n    0% {\n        transform: scale(0);\n        opacity: 1;\n    }\n    100% {\n        transform: scale(4);\n        opacity: 0;\n    }\n}\n\n/* dark overlay */\n@keyframes shrink {\n    from {\n        transform: scale(1.1);\n    }\n\n    scale {\n        transform: scale(1);\n    }\n}\n\n/* Media Queries */\n\n@media (max-height: 850px) and (min-width: 1080px) {\n    .player-container {\n        grid-template-rows: auto 12fr auto auto;\n        grid-template-columns: 3fr 1fr;\n        gap: 0;\n        row-gap: 1em;\n        column-gap: 1em;\n        padding: 1em 2em;\n    }\n\n    .player-container__upper-row {\n        grid-row: 1 / 2;\n        grid-column: 1 / -1;\n    }\n\n    .ship-list {\n        grid-row: 2 / -1;\n        grid-column: 2;\n        width: 100%;\n        min-width: 12ch;\n        height: 90%;\n        flex-direction: column;\n        overflow-y: auto;\n    }\n\n    .ship-list::-webkit-scrollbar {\n        height: 0px;\n        width: 5px;\n    }\n\n    .menu__main .game-board {\n        grid-row: 2 / 3;\n        grid-column: 1 / 2;\n        width: 100%;\n    }\n\n    .button-list {\n        grid-row: 3;\n        grid-column: 1 / 2;\n        width: 100%;\n    }\n\n    .menu-button {\n        padding: 0.2em 0;\n    }\n\n    .player-container__upper-row {\n        width: 100%;\n    }\n\n    .dropdown-container {\n        margin: 0 auto;\n    }\n}\n\n@media (max-width: 1080px) {\n    .menu__main {\n        margin: 2em 0;\n    }\n\n    .dropdown-container {\n        margin: 0 auto;\n    }\n\n    .player-containers {\n        flex-direction: column;\n        align-items: center;\n    }\n\n    .player-container {\n        width: 90%;\n        max-width: 500px;\n    }\n\n    .menu__main .game-board {\n        width: 80%;\n    }\n\n    .ship-list,\n    .button-list {\n        width: 90%;\n    }\n}\n\n@media (max-width: 786px) {\n    .game-main {\n        margin: 2em 0;\n    }\n\n    .board-container {\n        flex-direction: column;\n        padding: 3rem 0;\n        gap: 3em;\n    }\n\n    .game-main {\n        min-height: 95%;\n    }\n\n    .game-main .game-board {\n        width: 80%;\n    }\n\n    .pass-device-button {\n        font-size: 0.7rem;\n        padding: 0.5rem 1rem;\n    }\n\n    #startBtn {\n        padding: 0.3em 2.5em;\n    }\n\n    .player-containers {\n        margin: 1.2em 0;\n    }\n}\n\n@media (max-width: 580px) {\n    #title {\n        letter-spacing: 8px;\n        font-size: 2.5rem;\n    }\n\n    .button-list {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(12ch, 1fr));\n        gap: 0.4em;\n    }\n\n    .dropdown-container {\n        flex-direction: column;\n        margin: 0;\n    }\n\n    .player-containers {\n        padding: 0;\n    }\n\n    select {\n        margin: 0;\n        width: 80%;\n    }\n\n    .board-container {\n        padding: 0.5em 0;\n    }\n\n    .game-main {\n        justify-content: space-evenly;\n    }\n}\n\n@media (max-width: 480px) {\n    #title {\n        font-size: 1.8rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
